import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as MdIcons from "react-icons/md";

export const ExecutiveSidebarData = [
  {
    title: "Overall Categories",
    id: "spy3",
    to: "overallTable",
    cName: "nav-text",
    icon: <MdIcons.MdCategory />,
    display: true,
    canToggle: false,
  },
  {
    title: "Overall Recommendations",
    id: "spy3",
    to: "execRecommend",
    cName: "nav-text",
    icon: <MdIcons.MdRecommend />,
    display: true,
    canToggle: false,
  },
  {
    title: "Select Entities",
    id: "spy2",
    to: "entitySearch",
    cName: "nav-text",
    icon: <FaIcons.FaBuilding />,
    display: true,
    canToggle: false,
  },
  {
    title: "Entity Information",
    id: "spy3",
    to: "entityTitle",
    cName: "nav-text",
    icon: <AiIcons.AiFillInfoCircle />,
    display: false,
    canToggle: true,
  },
  {
    title: "Entity Categories",
    id: "spy3",
    to: "entityTable",
    cName: "nav-text",
    icon: <MdIcons.MdCategory />,
    display: false,
    canToggle: true,
  },
  {
    title: "Entity Recommendations",
    id: "spy3",
    to: "entityRecommend",
    cName: "nav-text",
    icon: <MdIcons.MdRecommend />,
    display: false,
    canToggle: true,
  },
];
